import React, { Component } from 'react';

export default class About extends Component {
    render() {
        return(
        <section id="about">
          <div className="row">
            <div className="three columns">
              <img className="profile-pic" src="images/foto.jpeg" alt="" />
            </div>
            <div className="nine columns main-col">
              <h2>About Me</h2>
              <p> Driven Game Programmer with two years of professional experience. Implemented various types of
                  games with a wide range of mechanics, systems and, technologies. A quick learner and versatile with engine/framework and
                  pipeline used. Excellent written and oral communication skills; capable of make detail-oriented input to designer,
                  artist, and fellow team members.
              </p>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Contact Details</h2>
                  <p className="address">
                    <span>Alija Rasyidi Daud</span><br />
                    <span>Bandung<br />
                      West Java, Indonesia
                    </span><br />
                    <span>(+62)87887884824</span><br />
                    <span>alijakoe@gmail.com</span>
                  </p>
                </div>
                <div className="columns download">
                  <p>
                    <a href="https://drive.google.com/file/d/1mMjFavh1viNRnoxHLN3Tp3P6zcZReH52/view?usp=sharing" className="button"><i className="fa fa-download" />Download Resume</a>
                  </p>
                </div>
              </div> {/* end row */}
            </div> {/* end .main-col */}
          </div>
        </section>
        )
    }
}